<template>
  <div class="main-content fasilitas kegiatan">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Galeri Kegiatan</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="fasilitas-containter">
      <div class="container">
        <div class="section-title text-center">
          <div class="row">
            <div class="col-md-12">
              <h2 class="text-uppercase mt-0 line-height-1">
                Galeri Kegiatan di
                <span class="text-theme-colored">Rumah Sakit UII</span>
              </h2>
            </div>
          </div>
        </div>
        <div class="section-content mt-30">
          <div v-if="galleries.length < 1" class="alert alert-danger">No data</div>
          <div class="row">
            <div
              :key="'gallery-' + item.id"
              v-for="item in galleries"
              class="col-xs-12 col-sm-6 col-md-6 col-lg-4 mb-30"
            >
              <img v-bind:src="JSON.parse(item.meta).meta_picture" alt />
              <h5 class="mt-15 mb-10 text-center">{{ item.title }}</h5>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import api from "../services/api";

export default {
  data() {
    return {
      show_loading: false,
      galleries: [],
    };
  },
  mounted() {
    this.getGalleries();
  },
  methods: {
    getGalleries() {
      this.show_loading = true;
      api
        .post(api.route.get.gallery)
        .then((res) => {
          let status = res.status;
          if (status) this.galleries = res.data;
          this.show_loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.show_loading = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Kegiatan.vue